import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import Modal from "react-modal";
import './styles/style.css';
import './styles/refinements.css';
// import './styles/custom.css';

Modal.setAppElement("#root");
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <App initialData={JSON.parse(document.getElementById('archive-data')?.textContent || '{}')} />
  </React.StrictMode>
);
